import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

/**
 * Geração e download de CSV no padrão usado pelo admin:
 * separador ";", linhas "\r\n", BOM UTF-8 (Excel reconhece acentos), datas "dd/MM/yyyy HH:mm".
 */
@Injectable({ providedIn: 'root' })
export class CsvExportService {

  /** Monta o CSV e dispara o download. `rows` são as células já formatadas (ou valores primitivos). */
  download(fileName: string, header: string[], rows: unknown[][]): void {
    const csv = [header, ...rows]
      .map(row => row.map(v => this.field(v)).join(';'))
      .join('\r\n');

    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  /** Nome de arquivo com carimbo de data/hora: prefixo_yyyy-MM-dd_HH-mm.csv */
  fileName(prefix: string): string {
    return `${prefix}_${formatDate(new Date(), 'yyyy-MM-dd_HH-mm', 'en-US')}.csv`;
  }

  field(value: unknown): string {
    if (value === null || value === undefined) return '';
    const text = String(value);
    if (text.includes(';') || text.includes('"') || text.includes('\n') || text.includes('\r')) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  }

  /** Data/hora para o CSV. `utc` = o valor veio sem fuso mas é UTC (padrão das datas da API). */
  date(value?: string | null, utc = false): string {
    if (!value) return '';
    const iso = utc && !/[zZ]|[+-]\d{2}:\d{2}$/.test(value) ? value + 'Z' : value;
    return formatDate(iso, 'dd/MM/yyyy HH:mm', 'en-US');
  }

  /** Número decimal com vírgula (pt-BR) para o Excel. */
  money(value?: number | null): string {
    if (value === null || value === undefined) return '';
    return value.toFixed(2).replace('.', ',');
  }

  bool(value?: boolean | null): string {
    return value ? 'Sim' : 'Não';
  }
}
